import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_V0_VERSION_PREFIX } from "../constants/urlPaths";
import {
  ExperiencesAvailabilityResponse,
  ExperiencesInitialSearch,
  ILocationQueryCoordinate,
  ILocationQueryLabel,
  IResponse,
  ResponseEnum,
} from "redmond";

export const experiencesApi = createApi({
  reducerPath: "experiences",
  baseQuery: fetchBaseQuery({ baseUrl: API_V0_VERSION_PREFIX }),
  tagTypes: ["Experiences", "ExperiencesDestination"],
  endpoints: (build) => ({
    getExperiencesAvailability: build.query<
      {
        Response: ResponseEnum;
        value: ExperiencesAvailabilityResponse;
      },
      ExperiencesInitialSearch
    >({
      query(req) {
        return {
          url: "experiences/availability",
          method: "POST",
          body: req,
        };
      },
      providesTags: ["Experiences"],
    }),
    getExperiencesDestination: build.query<
      IResponse,
      { query: ILocationQueryLabel | ILocationQueryCoordinate }
    >({
      query(req) {
        return {
          url: "autocomplete/experiences",
          method: "POST",
          body: req,
        };
      },
      providesTags: ["ExperiencesDestination"],
    }),
  }),
});

export const {
  useGetExperiencesAvailabilityQuery,
  useGetExperiencesDestinationQuery,
  useLazyGetExperiencesDestinationQuery,
} = experiencesApi;
